import React from 'react';
import Body from './Layout/Body';
import services from './../lib/Services';
import Powerplant from './Powerplant/Powerplant';

class App extends React.Component
{
	constructor(props)
	{
		super(props);
		this.state = { powerplants: [], height: null, width: window.innerWidth };
	}
	
	componentDidMount()
	{
		const pps = [];
        const steps = new Map();
        const codes = services.getUser().getAllAppCode();
        codes.forEach(code => {
            steps.set(code, 0);
        });
        // -- Recover powerplant step from GMAO
        services.getApi().getGmaoPowerplants().then(gmaoPowerplants => {
            // Convert code like "nogueres-sud" to local_id
            gmaoPowerplants.forEach(gmaoPp => {
                if(codes.has(gmaoPp.code)) {
                    steps.set(codes.get(gmaoPp.code), gmaoPp.statut);
                }
            });
        })        
        .catch()
        .finally(() => {
            services.getUser().getAllAppId().forEach( app_id => {
                services.getApi().getPowerplant(app_id).then(parameters => {
                    const pp = new Powerplant(app_id, parameters);
                    if(steps.has(app_id)) {
                        pp.setStep(steps.get(app_id));
                    }
                    if(services.getUser().isSuperAdmin()) {
                        services.getApi().getDailyTrackerAvailability(app_id, Date.now() - 86400000, Date.now())
                            .then(data => {
                                if(data.length > 0) {
                                    pp.setLastDailyTrackerAvailability(Number(data[0].value))
                                }
                            })
                            .catch()
                            .finally(() => {
                                pps.push(pp);
                                this.setState({ powerplants: pps});
                            });
                    } else {
                        pps.push(pp);
                        this.setState({ powerplants: pps});
                    }
                });
            });
        });;
	}

	componentWillMount(){
		//Mini screen
		if(this.state.width >= 992 && this.state.width <= 1200){
			this.setState({height: (window.innerHeight/500)*7 + 'vh'});
		} else{
			this.setState({height: (window.innerHeight/500) + 'vh'});
		}
	}
	
	render()
	{
		const total = this.state.powerplants.reduce((acc, pp) => acc + pp.getTotalPower(), 0);
		return (
				<div style={{background:'#0E202D', paddingBottom: this.state.height}}>
					<Body total={total} powerplants={this.state.powerplants} />
				</div>
		);
	}
}

export default App;